import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const WHMPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Create a temporary link element and click it to open in new tab
    const link = document.createElement('a');
    link.href = 'http://162.0.216.125:2087';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Navigate to admin dashboard instead of using history.back()
    if (user?.username) {
      navigate(`/admin/${user.username}/dashboard`);
    }
  }, [navigate, user]);
  
  return null; // This component doesn't render anything
};

export default WHMPage;
